import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MinioIngressList } from "../../api/ingressRpcApi";
import { listIngressAsync } from "./ingressThunks";
import { LoadingStatus } from "../../common/types";

export interface IListIngress {
  listIngressLoading: LoadingStatus;
  selectedSite: string;
  namespace: string;
  ingressList: MinioIngressList;
  validationErrors: { [key: string]: string };
}

const initialState: IListIngress = {
  listIngressLoading: "neverLoaded",
  selectedSite: "",
  namespace: "",
  ingressList: {},
  validationErrors: {},
};

export const listIngressReducer = createSlice({
  name: "listIngress",
  initialState,
  reducers: {
    setListIngressLoading: (state, action: PayloadAction<LoadingStatus>) => {
      state.listIngressLoading = action.payload;
    },
    setIngressSelectedSite: (state, action: PayloadAction<string>) => {
      state.selectedSite = action.payload;
    },
    setIngressNamespace: (state, action: PayloadAction<string>) => {
      state.namespace = action.payload;
    },
    setIngressList: (state, action: PayloadAction<MinioIngressList>) => {
      state.ingressList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(listIngressAsync.pending, (state) => {
        state.listIngressLoading = "loading";
      })
      .addCase(listIngressAsync.rejected, (state) => {
        state.listIngressLoading = "failed";
      })
      .addCase(listIngressAsync.fulfilled, (state, action) => {
        state.listIngressLoading = "idle";
        state.ingressList = action.payload;
      });
  },
});

export const {
  setListIngressLoading,
  setIngressSelectedSite,
  setIngressNamespace,
  setIngressList,
} = listIngressReducer.actions;

export default listIngressReducer.reducer;
